// extracted by mini-css-extract-plugin
module.exports = {"light":"TextButton_light__1jxPb","dark":"TextButton_dark__1GvSv","selected":"TextButton_selected__31_W7","speciesSelected":"TextButton_speciesSelected__1P9FX"};